export async function getOmnibusPriceFromAPI(brand, ID, currency) {
  if (!brand || !ID) {
    return;
  }
  let jsonData;

  try {
    const response = await fetch(createOmnibusEndpoint(brand, ID, currency));
    jsonData = await response.json();
  } catch (e) {
    return 0;
  }

  return jsonData.price;
}

export async function renderOmnibusPriceFromAPI(
  omnibusPriceContainer,
  price,
  variantPrice,
  has_promo,
) {
  if (
    !!variantPrice &&
    parseFloat(price) * 100 == variantPrice &&
    has_promo == 0
  ) {
    hideomnibusPriceContainer(omnibusPriceContainer);
    return;
  }

  if (has_promo == 0) {
    hideomnibusPriceContainer(omnibusPriceContainer);
    return;
  }

  if (!price && has_promo == 0) {
    hideomnibusPriceContainer(omnibusPriceContainer);
    return;
  }

  omnibusPriceContainer.classList.remove('hidden');
  const omnibuspriceValue = omnibusPriceContainer.querySelector(
    '.omnibusprice-value',
  );
  omnibuspriceValue.innerText = window.theme.Currency.formatMoney(
    price.toFixed(2),
    window.theme.strings.moneyFormat,
  );
}

const hideomnibusPriceContainer = (omnibusPriceContainer) => {
  if (!omnibusPriceContainer.classList.contains('hidden')) {
    omnibusPriceContainer.classList.add('hidden');
  }
};

export function createOmnibusEndpoint(brand, ID, currency) {
  const currencyParam = currency ? `&currency=${currency}` : '';
  return `https://omnibus.filoblu.com/?brand=${brand}&sku=${ID}&market=${window.location.host}${window.Shopify.routes.root}${currencyParam}`;
}
